// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.body {
  text-align: center;
  padding: 0;
  margin: 0;
}

.payment-succe {
  color: rgb(210, 222, 38);
  font-family: "Nunito Sans", "Helvetica Neue", sans-serif;
  font-weight: 900;
  font-size: 30px;
  margin-bottom: 10px;
}

.success-message {
  color: rgb(0, 57, 117);
  font-family: "Nunito Sans", "Helvetica Neue", sans-serif;
  font-weight: 900;
  font-size: 15px;
  margin-bottom: 0px;
}

.i-sign-succ {
  color: rgb(210, 222, 38);
  font-size: 100px;
  line-height: 200px;
  margin-left: -15px;
}

.card {
  background: white;
  padding: 15px 20px;
  border-radius: 4px;
  display: inline-block;
  margin: 0 auto;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
}

.payment-btn {
  height: 40px;
  min-width: 100px;
  border-radius: 5px;
  margin-right: 10px;
  background: #fff;
  color: rgb(237, 28, 36);
  border: 2px solid rgb(237, 28, 36);
  margin-top: 30px;
  display: inline-block;
  font-size: 14px;
  font-weight: 700;
}

.symbol-cicle-succ {
  border: 2.5px solid rgb(210, 222, 38);
  border-radius: 200px;
  height: 200px;
  width: 200px;
  background: #fff;
  margin: 0 auto;
}

.header-right {
  float: right !important;
}

.header {
  overflow: hidden;
  background-color: rgb(237, 28, 36);
}

.header-div {
  float: left;
  color: black;
  text-align: center;
  text-decoration: none;
  font-size: 18px;
  line-height: 25px;
  border-radius: 4px;
}

.logo {
  width: 180px;
}

@media (max-device-width: 768px) {
  .logo {
    width: 150px;
  }
  .symbol-cicle-succ {
    border-radius: 150px;
    height: 150px;
    width: 150px;
  }
  .i-sign-succ {
    line-height: 150px;
    margin-left: -15px;
  }
  .payment-btn {
    min-width: 85px;
  }
}
@media (max-device-width: 300px) {
  .logo {
    width: 130px;
  }
  .payment-btn {
    min-width: 80px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/agent/agent-reject-view/agent-reject-view.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;AACF;;AACA;EACE,wBAAA;EACA,wDAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAEF;;AACA;EACE,sBAAA;EACA,wDAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAEF;;AACA;EACE,wBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAEF;;AACA;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;AAEF;;AACA;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kCAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AAEF;;AAAA;EACE,qCAAA;EACA,oBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AAGF;;AAAA;EACE,uBAAA;AAGF;;AADA;EACE,gBAAA;EACA,kCAAA;AAIF;;AADA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAIF;;AADA;EACE,YAAA;AAIF;;AADA;EACE;IACE,YAAA;EAIF;EADA;IACE,oBAAA;IACA,aAAA;IACA,YAAA;EAGF;EADA;IACE,kBAAA;IACA,kBAAA;EAGF;EAAA;IACE,eAAA;EAEF;AACF;AAAA;EACE;IACE,YAAA;EAEF;EACA;IACE,eAAA;EACF;AACF","sourcesContent":[".body {\r\n  text-align: center;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n.payment-succe {\r\n  color: rgb(210, 222, 38);\r\n  font-family: 'Nunito Sans', 'Helvetica Neue', sans-serif;\r\n  font-weight: 900;\r\n  font-size: 30px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.success-message {\r\n  color: rgb(0, 57, 117);\r\n  font-family: 'Nunito Sans', 'Helvetica Neue', sans-serif;\r\n  font-weight: 900;\r\n  font-size: 15px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.i-sign-succ {\r\n  color: rgb(210, 222, 38);\r\n  font-size: 100px;\r\n  line-height: 200px;\r\n  margin-left: -15px;\r\n}\r\n\r\n.card {\r\n  background: white;\r\n  padding: 15px 20px;\r\n  border-radius: 4px;\r\n  display: inline-block;\r\n  margin: 0 auto;\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 90%;\r\n}\r\n\r\n.payment-btn {\r\n  height: 40px;\r\n  min-width: 100px;\r\n  border-radius: 5px;\r\n  margin-right: 10px;\r\n  background: #fff;\r\n  color: rgb(237, 28, 36);\r\n  border: 2px solid rgb(237, 28, 36);\r\n  margin-top: 30px;\r\n  display: inline-block;\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n}\r\n.symbol-cicle-succ {\r\n  border: 2.5px solid rgb(210, 222, 38);\r\n  border-radius: 200px;\r\n  height: 200px;\r\n  width: 200px;\r\n  background: #fff;\r\n  margin: 0 auto;\r\n}\r\n\r\n.header-right {\r\n  float: right !important;\r\n}\r\n.header {\r\n  overflow: hidden;\r\n  background-color: rgb(237, 28, 36);\r\n}\r\n\r\n.header-div {\r\n  float: left;\r\n  color: black;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  font-size: 18px;\r\n  line-height: 25px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.logo {\r\n  width: 180px;\r\n}\r\n\r\n@media (max-device-width: 768px) {\r\n  .logo {\r\n    width: 150px;\r\n  }\r\n\r\n  .symbol-cicle-succ {\r\n    border-radius: 150px;\r\n    height: 150px;\r\n    width: 150px;\r\n  }\r\n  .i-sign-succ {\r\n    line-height: 150px;\r\n    margin-left: -15px;\r\n  }\r\n\r\n  .payment-btn {\r\n    min-width: 85px;\r\n  }\r\n}\r\n@media (max-device-width: 300px) {\r\n  .logo {\r\n    width: 130px;\r\n  }\r\n\r\n  .payment-btn {\r\n    min-width: 80px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
